import React from 'react';
import styles from './Expander.scss';

const Expander = ({ expanded, onClick, tag }) => (
	<div onClick={onClick} className={`${styles.Expander}`} data-tag={tag}>
		<div className={expanded ? styles.expanded : styles.collapsed} />
	</div>
);

export { Expander };
